module.exports = __webpack_public_path__ + "static/united-kingdom-a7fc19d7719f03b403aef0dd038d505b.png";